import type { RouterConfig } from '@nuxt/schema'

export default {
  // https://router.vuejs.org/api/interfaces/routeroptions.html#routes
  routes(routes) {
    return [
      ...routes,
      {
        name: 'voucher-start',
        path: '/:lang?/voucher/start',
        component: () => import('~/core/pages/checkout/voucher/Start.page.vue'),
        meta: {
          layout: 'checkout',
        }
      },
      {
        name: 'voucher-buyer',
        path: '/:lang?/voucher/:voucherpurchaseuuid/checkout/buyer',
        component: () => import('~/core/pages/checkout/voucher/Buyer.page.vue'),
        meta: {
          layout: 'checkout',
        }
      },
      {
        name: 'voucher-payment',
        path: '/:lang?/voucher/:voucherpurchaseuuid/checkout/payment',
        component: () => import('~/core/pages/checkout/voucher/Payment.page.vue'),
        meta: {
          layout: 'checkout',
        }
      },
      {
        name: 'voucher-redsys-challenge',
        path: '/:lang?/voucher/:voucherpurchaseuuid/redsys/challenge',
        component: () => import('~/core/pages/checkout/voucher/Redsys.Challenge.page.vue'),
        meta: {
          layout: 'checkout',
        }
      },
      {
        name: 'voucher-confirmation',
        path: '/:lang?/voucher/:voucherpurchaseuuid/confirmation',
        component: () => import('~/core/pages/checkout/voucher/Confirmation.page.vue'),
        meta: {
          layout: 'thanks',
        }
      },
      // Get away
      {
        name: 'get-away-start',
        path: '/:lang?/purchase/start',
        component: () => import('~/core/pages/checkout/get-away/Start.page.vue'),
        meta: {
          layout: 'checkout',
        }
      },
      {
        name: 'get-away-buyer',
        path: '/:lang?/purchase/:packagepurchaseuuid/checkout/buyer',
        component: () => import('~/core/pages/checkout/get-away//Buyer.page.vue'),
        meta: {
          layout: 'checkout',
        }
      },
      {
        name: 'get-away-payment',
        path: '/:lang?/purchase/:packagepurchaseuuid/checkout/payment',
        component: () => import('~/core/pages/checkout/get-away/Payment.page.vue'),
        meta: {
          layout: 'checkout',
        }
      },
      {
        name: 'get-away-confirmation',
        path: '/:lang?/purchase/:packagepurchaseuuid/confirmation',
        component: () => import('~/core/pages/checkout/get-away/Confirmation.page.vue'),
        meta: {
          layout: 'thanks',
        }
      },
      {
        name: 'get-away-ko',
        path: '/:lang?/purchase/:packagepurchaseuuid/ko',
        component: () => import('~/core/pages/checkout/get-away/KO.page.vue'),
        meta: {
          layout: 'checkout',
        }
      },
    ]
  },
} satisfies RouterConfig
